import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@ui/Form";
import { EXCEL_FILE_ACCEPTED_EXTENSIONS } from "@/constants/validation";
import { useMultiStepForm } from "@/hooks";
import { SummaryCard } from "@/components/Cards";
import DownloadExampleButton from "@/components/DownloadExampleButton";
import { FileUpload } from "@/components/FileUpload";

export const SummaryCard3: FC = () => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();

  return (
    <SummaryCard title={t("summary.card3")} dataTest="summary-card3">
      <div className="space-y-4">
        <FormLabel data-test="upload-label">{t("summary.file.label")}</FormLabel>
        <div className="flex flex-row flex-wrap items-center gap-4" data-test="summary-upload-note">
          <p className="font-medium">{t("summary.file.exampleNote")}</p>
          <DownloadExampleButton fileUrl="/examples/year-example.xlsx" />
        </div>
        <p className="text-sm font-light" data-test="summary-upload-units-hint">
          {t("summary.file.unitsHint")}
        </p>
        <FormField
          control={form.control}
          name="summary.excelProfile"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <FileUpload
                  value={field.value}
                  onChange={field.onChange}
                  accept={EXCEL_FILE_ACCEPTED_EXTENSIONS.join(",")}
                  isError={Boolean(form.formState.errors.summary?.excelProfile)}
                  dataTest="upload"
                />
              </FormControl>
              <FormMessage data-test="upload-error" />
            </FormItem>
          )}
        />
      </div>
    </SummaryCard>
  );
};
